import './App.css';

import Home from './components/Home';
import Resources from './components/Resources';
import { Faculty } from './components/Faculty';
import { FAQ } from './components/FAQ';
import { Courses } from './components/Courses';
import { About } from './components/About';
import { Careers } from './components/Careers';
import { BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
function App() {
  return (
    <BrowserRouter>
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/resources" element={<Resources />} />
            <Route exact path="/faculty" element={<Faculty/>} />
            <Route exact path="/faq" element={<FAQ />} />
            <Route exact path="/courses" element={<Courses/>} />
            <Route exact path="/careers" element={<Careers />} />
            <Route exact path="/about" element={<About />} />
        </Routes>
    </BrowserRouter>
);
}

export default App;
